import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const useAIHelperNavigation = () => {
  const navigate = useNavigate();
  const artifactId = useSelector((state: any) => state.artifactDetails?.data?.id);

  const clearSelectionsSessionHistory = () => {
    sessionStorage.removeItem(`artifact_${artifactId}_skill_selections`);
    sessionStorage.removeItem(`artifact_${artifactId}_selected_areas`);
    sessionStorage.removeItem(`artifact_${artifactId}_sorted_order`);
  };

  const handleBackToList = () => {
    clearSelectionsSessionHistory();
    navigate("/base/#artifacts");
  };

  const handleGoToGetStarted = () => {
    navigate("/artifact-review/get-started");
  };

  const handleGoToSkillsReview = () => {
    navigate("/artifact-review/skills-review");
  };

  const handleGoToSubskillsReview = () => {
    navigate("/artifact-review/subskills-review");
  };

  const handleGoToShareFeedback = () => {
    navigate("/artifact-review/share-feedback"); 
  }

  return {
    handleBackToList,
    handleGoToSkillsReview,
    handleGoToSubskillsReview,
    handleGoToGetStarted,
    handleGoToShareFeedback,
    clearSelectionsSessionHistory,
  };
};

export default useAIHelperNavigation;
